<template>
	<div>
		<div class="row mb-4">
			<div class="col-12 d-flex align-items-center">
				<h1 class="mb-0">{{ $t("upload-users") }}</h1>
			</div>
		</div>

		<StepIndicator v-if="step <= 4" :steps="stepLabels" :current-step="step" class="mb-4" />

		<StepUserType
			v-if="step === 1"
			:user-type.sync="userType"
			@next="onUserTypeChosen"
		/>

		<StepPreview
			v-if="step === 2"
			:title="$t('upload-users-csv')"
			:loading-preview="loadingPreview"
			:preview="preview"
			@file-selected="onFileSelected"
			@next="step = 3"
			@back="step = 1"
		/>

		<StepMapColumns
			v-if="step === 3"
			:instructions="$t('match-user-fields-to-csv-columns')"
			:field-defs="fieldDefs"
			:column-options="columnOptions"
			:column-map="columnMap"
			:validating="validating"
			:mapping-valid="mappingValid"
			:preview-rows="preview ? preview.rows : []"
			:loading-fields="loadingFields"
			@validate="runValidation"
			@back="step = 2"
		/>

		<StepReviewIssues
			v-if="step === 4"
			:validation="validation"
			:error-count="errorCount"
			:warning-count="warningCount"
			:skip-invalid-rows.sync="skipInvalidRows"
			:send-activation-email.sync="sendActivationEmail"
			:activate-accounts.sync="activateAccounts"
			:importing="importing"
			@import="runImport"
			@back="step = 3"
		/>

		<StepResults
			v-if="step === 5"
			:import-results="importResults"
			@reset="reset"
		/>
	</div>
</template>

<script>
import { CsvUploadWizardMixin } from '@/mixins';
import StepIndicator    from 'src/components/Util/StepIndicator.vue';
import StepUserType     from 'src/components/Users/Upload/StepUserType.vue';
import StepPreview      from 'src/components/Util/Upload/StepPreview.vue';
import StepMapColumns   from 'src/components/Util/Upload/StepMapColumns.vue';
import StepReviewIssues from 'src/components/Users/Upload/StepReviewIssues.vue';
import StepResults      from 'src/components/Users/Upload/StepResults.vue';

export default {
	mixins: [CsvUploadWizardMixin],

	components: {
		StepIndicator,
		StepUserType,
		StepPreview,
		StepMapColumns,
		StepReviewIssues,
		StepResults,
	},

	data() {
		return {
			step:       1,
			stepLabels: ['User Type', 'Preview', 'Map Columns', 'Review Issues'],

			// Step 1
			userType: null,

			// Step 3
			loadingFields: false,
			fieldDefs: [],
			columnMap: {},

			// Step 4
			sendActivationEmail: true,
			activateAccounts:    false,
		};
	},

	computed: {
		csvEndpoints() {
			return {
				preview:  '/users/upload/preview',
				validate: '/users/upload/validate',
				import:   '/users/upload/import',
			};
		},
	},

	methods: {
		extraFormData() {
			return { user_type: this.userType };
		},

		onUserTypeChosen() {
			this.step = 2;
			this.fetchFields();
		},

		fetchFields() {
			this.loadingFields = true;
			this.fieldDefs = [];
			this.columnMap = {};

			const fd = this.buildFormData();

			fetch(`${this.$settings.APIBaseURL}/users/upload/fields`, { method: 'POST', body: fd })
				.then(r => r.json())
				.then(res => {
					if (res.status === 'SUCCESS') {
						this.fieldDefs = res.fields;
						this.columnMap = Object.fromEntries(res.fields.map(f => [f.key, null]));
						if (this.preview) this.autoDetectColumns(this.preview.headers);
					}
				})
				.catch(err => console.error('Fields error:', err))
				.finally(() => { this.loadingFields = false; });
		},

		onFileSelected(file) {
			this.fetchPreview(file);
		},

		runValidation() {
			this.postValidation().then(res => {
				if (res && res.status === 'SUCCESS') this.step = 4;
			});
		},

		runImport() {
			this.postImport({
				send_activation_email: this.sendActivationEmail ? '1' : '0',
				activate_accounts:     (!this.sendActivationEmail && this.activateAccounts) ? '1' : '0',
			}).then(res => {
				if (res && res.status === 'SUCCESS') this.step = 5;
			});
		},
	},
};
</script>
